import axios from 'axios'
export const proxy = import.meta.env.VITE_SERVER_URL
export const url = `${proxy}/api`
import { HeadersWithCredentials } from './header'

// A 401 on a request that carried the stored token means the session is dead (secret rotated, user
// banned or deleted, token expired). Login attempts carry no stored token, so their 401s are not one.
export const isDeadSession = (error, storedToken) =>
    error?.response?.status === 401 &&
    Boolean(storedToken) &&
    error?.config?.headers?.Authorization === 'Bearer ' + storedToken

// Registered once for every axios call, whatever service file made it: drop the session and reload,
// so the app starts logged out and PrivateRoute sends the athlete to /connect (instead of each page
// showing its generic error toast while the dead token stays in localStorage).
let reloading = false
const onUnauthorized = (error) => {
    if (!reloading && isDeadSession(error, localStorage.getItem('token'))) {
        reloading = true
        localStorage.clear()
        sessionStorage.clear()
        window.location.reload()
    }
    return Promise.reject(error)
}
axios.interceptors.response.use(undefined, onUnauthorized)

export const request = async (method, path, body, token, params) => {
    token = token || localStorage.getItem('token')
    return await axios({
        method,
        url: `${url}/${path}`,
        headers: HeadersWithCredentials(token),
        data: body,
        params,
    })
        .then((response) => {
            return {
                error: false,
                data: response.data,
            }
        })
        .catch((error) => {
            if (error.response?.status === 401) return { error: true, status: 401 }
            return {
                error: true,
                status: error.response?.status,
                data: error.response?.data,
            }
        })
}
